export default "__VITE_ASSET__Dkf0TR4k__"